<h2 mat-dialog-title translate>Select Year</h2>
<mat-dialog-content>
<div style="position: relative; bottom: 10px;top: -10px;margin-top: 10px;" class="robotoMedium">{{selectedForm.InstanceName | translate}}</div>
<div translate>For which year are you submitting this e-Form?</div>
<tyl-form-field label='Academic Year'>
  <mat-select #refStudent id='ddlYear' [(ngModel)]='selectedYear' name='Year' required>
    <mat-option *ngFor='let year of years' [value]='year'>{{year.Description}}</mat-option>
  </mat-select>
</tyl-form-field>
</mat-dialog-content>
<mat-dialog-actions>
  <div class='flex-footer-left'>

  </div>
  <div class='flex-footer-right'>
    <error-prompt [errorList]="errors"></error-prompt>
    <tyl-button image="next arrow.png" label="Next" (clickEvent)="nextClick()"></tyl-button>
    <tyl-button image="cancel.png" label="Cancel" (clickEvent)="cancelClick()"></tyl-button>
  </div>
</mat-dialog-actions>
